"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FlagLU = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, height: '1em', viewBox: '0 0 24 24', width: '1em', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react_1.default.createElement("title", null, "Flag of Luxembourg"),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: 'M1 0C.45 0 0 .451 0 1v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.549-.45-1-1-1H1z', id: 'prefix__a' })),
        react_1.default.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react_1.default.createElement("g", { transform: 'translate(2 5)' },
                react_1.default.createElement("mask", { id: 'prefix__b', fill: '#fff' },
                    react_1.default.createElement("use", { xlinkHref: '#prefix__a' })),
                react_1.default.createElement("path", { fill: '#ED2939', mask: 'url(#prefix__b)', d: 'M0 4.999h20V0H0z' }),
                react_1.default.createElement("path", { fill: '#00A1DE', mask: 'url(#prefix__b)', d: 'M0 15h20V8.999H0z' }),
                react_1.default.createElement("path", { fill: '#FFF', mask: 'url(#prefix__b)', d: 'M0 8.999h20v-4H0z' })),
            react_1.default.createElement("path", { d: 'M0 0h24v24H0z' }))));
};
exports.default = FlagLU;
